export const openUrl = (url: string) => {
  if (url.slice(0, 4) !== 'http') {
    window.open('http://' + url);
  } else {
    window.open(url);
  }
};
